const toolbarModule = {
  namespaced: true,

  state: {
    display: false,
    actions: [],
  },

  actions: {
    setActions({ dispatch, commit }, actions) {
      dispatch('displayToolbar');
      commit('setActions', actions);
    },
    unsetActions({ commit }) {
      commit('setActions', []);
    },
    displayToolbar({ commit }) {
      commit('setDisplay', true);
    },
    hideToolbar({ commit }) {
      commit('setDisplay', false);
    },
  },

  mutations: {
    setActions(state, payload) {
      state.actions = payload;
    },
    setDisplay(state, payload) {
      state.display = payload;
    },
  },

  getters: {
    getActions(state) {
      return state.actions;
    },
    getDisplay(state) {
      return state.display;
    },
  },
};

export default toolbarModule;
